import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../services/api';
import { useAuth } from '../context/AuthContext';
import FeedbackForm from './FeedbackForm';

const LAYOUT_FIX = 'formatting_lost';
const FEEDBACK_CATEGORIES = ['inaccurate_translation', 'grammar', LAYOUT_FIX, 'missing_text'];

function DocumentFeedback({ documentId }) {
  const { t } = useTranslation('chat');
  const { user } = useAuth();
  // undefined while loading, null when not rated yet
  const [existing, setExisting] = useState(undefined);

  useEffect(() => {
    if (!documentId) return;
    api.getDocumentFeedback(documentId).then(
      (feedback) => setExisting(feedback || null),
      (error) => console.error('Failed to check existing feedback:', error),
    );
  }, [documentId]);

  const thanks = (categories) => (
    categories?.includes(LAYOUT_FIX) ? t('feedback.layoutFixPromise', { email: user?.email }) : t('feedback.thankYou')
  );

  if (!documentId || existing === undefined) return null;
  if (existing) {
    return (
      <div className="document-feedback submitted">
        <span className="thank-you-message">{thanks(existing.categories)}</span>
      </div>
    );
  }
  return (
    <FeedbackForm
      categories={FEEDBACK_CATEGORIES}
      categoryPrefix="feedback.categories"
      thanks={thanks}
      onSubmit={({ rating, comment, categories }) => api.submitFeedback(documentId, rating, comment, categories)}
      onVoice={({ rating, categories, blob, language }) =>
        api.submitVoiceFeedback(documentId, rating, categories, blob, language)
      }
    />
  );
}

export default DocumentFeedback;
